
<template>
  <div class="footer">
    <!-- TODO: refactor markup -->

    <div class="container">
      <div class="row">
        <div class="col-md-8 mx-auto py-3 text-center">
          <div style="font-size:11px;">
            <span>Licenta turism nr. 2186 / 28.08.2020 | </span>
            <span class="text-weight-medium">Polita asigurare seria If-I  nr. 3590 / 06.12.2022-05.12.2023</span><br/>
            <span>Brevet turism nr. 16290 / 06.04.2010 - Pandel Andreea |</span>
            <span>M.D.R.T. - 0800.86.82.82</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
